import React from 'react';
//colors
import { MuiThemeProvider,createMuiTheme } from '@material-ui/core/styles';
// import white from '@material-ui/core/colors/white';

//Button, Radiobuttons
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';

//Forms
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  label: {
    '&, & + $label': {
      color: 'white',
    },
  },
});

const theme = createMuiTheme({
  palette: {
        primary: {
          main: '#f9fbe7',
        },  
      }
});

class EventView extends React.Component {


    state = { 
      share_through_other_app :false,
      download_videoid:false,
      earning_achievement:false,
      receive_shared_video:false,
      share_app_bluetooth:false,
      share_app_through_other:false,
      share_from_sawbo_to_sawbo:false,
      share_from_sawbo_to_other:false,
      view_offline:false,
      view_online:false,
      eventName:''
  };

  handleEventChange = name => event => {
    this.setState({ [name]: event.target.checked });
    var eventN = name;

    this.props.onChange(eventN);  
  };

  reset(event) {
    this.setState({  
      share_through_other_app :false,
      download_videoid:false,
      earning_achievement:false,
      receive_shared_video:false,
      share_app_bluetooth:false,
      share_app_through_other:false,
      share_from_sawbo_to_sawbo:false,
      share_from_sawbo_to_other:false,
      view_offline:false,
      view_online:false,
      eventName:''
  });
  this.props.onChange('');  

  };

  render() {
    const { classes } = this.props;

    const {   
      share_through_other_app ,
      download_videoid,
      earning_achievement,
      receive_shared_video,
      share_app_bluetooth,
      share_app_through_other,
      share_from_sawbo_to_other,
      share_from_sawbo_to_sawbo,
      view_offline,
      view_online, } = this.state;

    return (

      <div>

    <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup>
          <MuiThemeProvider theme={theme}>

            <FormControlLabel
            classes={{
              label: classes.label,
            }}
              control={
                <Checkbox color="primary"  checked={download_videoid} onChange={this.handleEventChange('download_videoid')} value="download_videoid" />
              }style={{ backgroundColor: '#E6194B'}}
              label="Download Video"
            />
            <FormControlLabel
            classes={{
              label: classes.label,
            }}
              control={
                <Checkbox color="primary"  checked={view_online} onChange={this.handleEventChange('view_online')} value="view_online" />
              }style={{backgroundColor: '#3CB44B'}}
              label="View Video Online"
            />
            <FormControlLabel
              control={
                <Checkbox color="primary" checked={view_offline} onChange={this.handleEventChange('view_offline')} value="view_offline"/>
              }style={{ backgroundColor: '#FFE119'}} 
              label="View Video Offline"
            />
             <FormControlLabel
             classes={{
              label: classes.label,
            }}
              control={
                <Checkbox color="primary" checked={share_from_sawbo_to_sawbo} onChange={this.handleEventChange('share_from_sawbo_to_sawbo')} value="share_from_sawbo_to_sawbo"/>
              }style={{ backgroundColor: '#0082C8'}} 
              label="Share video from SAWBO app to SAWBO app"
            />
            <FormControlLabel
            classes={{
              label: classes.label,
            }}
              control={
                <Checkbox color="primary"  checked={share_from_sawbo_to_other} onChange={this.handleEventChange('share_from_sawbo_to_other')} value="share_from_sawbo_to_other"/>
              }style={{ backgroundColor: '#F58230'}}
              label="Share video from SAWBO app to another device"
            />
            <FormControlLabel
            classes={{
              label: classes.label,
            }}
              control={
                <Checkbox color="primary" checked={share_through_other_app} onChange={this.handleEventChange('share_through_other_app')} value="share_through_other_app"/>
              }style={{ backgroundColor: '#911EB4'}} 
              label="Share video through another app"
            />
            <FormControlLabel

              control={
                <Checkbox color="primary"  checked={receive_shared_video} onChange={this.handleEventChange('receive_shared_video')} value="receive_shared_video"/>
              }style={{ backgroundColor: '#46F0F0'}}
              label="Receive shared video"
            />
            <FormControlLabel
            classes={{
              label: classes.label,
            }}
              control={
                <Checkbox color="primary"  checked={share_app_bluetooth} onChange={this.handleEventChange('share_app_bluetooth')} value="share_app_bluetooth"/>
              }style={{ backgroundColor: '#F032E6'}}
              label="Share app through Bluetooth"
            />
            <FormControlLabel
              control={
                <Checkbox color="primary"  checked={share_app_through_other} onChange={this.handleEventChange('share_app_through_other')} value="share_app_through_other"/>
              }style={{ backgroundColor: '#D2F53C'}} 
              label="Share app through other application"
            />
              {/* <FormControlLabel
              control={
                <Checkbox checked={antoine} onChange={this.handleEventChange('')} value=""/>
              }
              label="App crashes"
            />
             <FormControlLabel
              control={
                <Checkbox checked={antoine} onChange={this.handleEventChange('')} value=""/>
              }
              label="Rating an animation"
            />                     */}
            <FormControlLabel
              classes={{
                label: classes.label,
              }}
              control={
                <Checkbox color="primary"  checked={earning_achievement} onChange={this.handleEventChange('earning_achievement')} value="earning_achievement" />
              }
              style={{backgroundColor: '#800000'}}
              label="Earning an achievement"

            />
            </MuiThemeProvider>
          </FormGroup>
          <Button  size="large" color="primary" onClick={ this.reset.bind(this)} style={{marginLeft:80}}>
            Reset
          </Button>
        </FormControl>
       
      </div>
   
    </div>
        
      );
    }
  }

//   const mapState = state => ({
//     eventName: state.eventName,

// });

// const mapDispatch = dispatch => ({

// });


  export default withStyles(styles)(EventView);;


